import { crosshair2 } from "@lucide/lab";
import { Icon as LucideIcon, LucideProps } from "lucide-react";

export function Crosshair(props: LucideProps) {
    return <LucideIcon iconNode={crosshair2} {...props} />;
}
